/* Global video autoplay + loop enforcement (desktop & mobile) */
(function () {
  function ensureVideo(video) {
    if (!video || video.dataset.laraPlay) return;
    video.dataset.laraPlay = '1';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function activateDeferredMedia(container) {
    if (!container.querySelectorAll) return;
    container.querySelectorAll('deferred-media:not([data-lara-loaded])').forEach(function (el) {
      var tpl = el.querySelector('template');
      if (!tpl) return;
      var node = tpl.content.querySelector('video, iframe');
      if (!node) return;
      el.setAttribute('data-lara-loaded', '');
      el.setAttribute('loaded', '');
      el.appendChild(node.cloneNode(true));
    });
  }

  function init() {
    activateDeferredMedia(document);
    document.querySelectorAll('video').forEach(ensureVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.MutationObserver) {
    var laraTimer;
    new MutationObserver(function () {
      clearTimeout(laraTimer);
      laraTimer = setTimeout(function () {
        activateDeferredMedia(document);
        document.querySelectorAll('video').forEach(ensureVideo);
      }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
